"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NeighborUpdateManager = exports.DEFAULT_NEIGHBOR_UPDATE_INTERVAL = void 0;
const dht_1 = require("@streamr/dht");
const utils_1 = require("@streamr/utils");
const NetworkRpc_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc");
const NetworkRpc_client_1 = require("../../../generated/packages/trackerless-network/protos/NetworkRpc.client");
const NeighborUpdateRpcLocal_1 = require("./NeighborUpdateRpcLocal");
const NeighborUpdateRpcRemote_1 = require("./NeighborUpdateRpcRemote");
const logger = new utils_1.Logger(module);
exports.DEFAULT_NEIGHBOR_UPDATE_INTERVAL = 10 * 1000;
class NeighborUpdateManager {
    abortController;
    options;
    rpcLocal;
    constructor(options) {
        this.abortController = new AbortController();
        this.rpcLocal = new NeighborUpdateRpcLocal_1.NeighborUpdateRpcLocal(options);
        this.options = options;
        this.options.rpcCommunicator.registerRpcMethod(NetworkRpc_1.NeighborUpdate, NetworkRpc_1.NeighborUpdate, 'neighborUpdate', (req, context) => this.rpcLocal.neighborUpdate(req, context));
    }
    async start() {
        await (0, utils_1.scheduleAtInterval)(() => this.updateNeighborInfo(), this.options.neighborUpdateInterval, false, this.abortController.signal);
    }
    stop() {
        this.abortController.abort();
    }
    async updateNeighborInfo() {
        logger.trace(`Updating neighbor info to nodes`);
        const neighborDescriptors = this.options.neighbors.getAll().map((neighbor) => neighbor.getPeerDescriptor());
        const startTime = Date.now();
        await Promise.allSettled(this.options.neighbors.getAll().map(async (neighbor) => {
            const res = await this.createRemote(neighbor.getPeerDescriptor()).updateNeighbors(this.options.streamPartId, neighborDescriptors);
            const nodeId = (0, dht_1.toNodeId)(neighbor.getPeerDescriptor());
            this.options.neighbors.get(nodeId).setRtt(Date.now() - startTime);
            if (res.removeMe) {
                this.options.neighbors.remove(nodeId);
                this.options.neighborFinder.start([nodeId]);
            }
        }));
    }
    createRemote(targetPeerDescriptor) {
        return new NeighborUpdateRpcRemote_1.NeighborUpdateRpcRemote(this.options.localPeerDescriptor, targetPeerDescriptor, this.options.rpcCommunicator, NetworkRpc_client_1.NeighborUpdateRpcClient);
    }
}
exports.NeighborUpdateManager = NeighborUpdateManager;
//# sourceMappingURL=NeighborUpdateManager.js.map